const $aa267f0165588797$var$converters = {
    days: (value)=>value * 864e5,
    hours: (value)=>value * 36e5,
    minutes: (value)=>value * 6e4,
    seconds: (value)=>value * 1e3,
    milliseconds: (value)=>value,
    microseconds: (value)=>value / 1e3
};
const $aa267f0165588797$export$ff695c3374a8851c = (object)=>Object.entries(object).reduce((milliseconds, [key, value])=>{
        return milliseconds + $aa267f0165588797$var$converters[key](value);
    // return acc;
    }, 0);
const $aa267f0165588797$export$a4cfb53d2e8c8e2a = (ms)=>({
        days: ms / 864e5,
        hours: ms / 36e5,
        minutes: ms / 6e4,
        seconds: ms / 1e3,
        milliseconds: ms,
        microseconds: ms * 1e3
    });


const $dad545c909cfec2d$var$formats = [
    "microseconds",
    "milliseconds",
    "seconds",
    "minutes",
    "hours",
    "days"
];
const $dad545c909cfec2d$var$$inputs = $dad545c909cfec2d$var$formats.reduce((acc, curr)=>{
    const $input = document.querySelector(`input[data-format="${curr}"]`);
    acc[curr] = $input;
    return acc;
}, {});
$dad545c909cfec2d$var$render(0);
Object.values($dad545c909cfec2d$var$$inputs).forEach((el)=>{
    el.addEventListener("keyup", (e)=>{
        const format = e.target.dataset.format;
        const value = parseInt(e.target.value);
        const ms = (0, $aa267f0165588797$export$ff695c3374a8851c)({
            [format]: value
        });
        $dad545c909cfec2d$var$render(ms);
    });
    el.addEventListener("focus", (e)=>{
        e.target.select();
    });
    el.parentNode.querySelector(".clipboard").addEventListener("click", ()=>{
        el.select();
        document.execCommand("copy");
    });
});
function $dad545c909cfec2d$var$render(ms = 0) {
    const formatted = (0, $aa267f0165588797$export$a4cfb53d2e8c8e2a)(ms);
    Object.entries($dad545c909cfec2d$var$$inputs).forEach(([format, $input])=>{
        if (document.activeElement !== $input) $input.value = formatted[format] || 0;
    });
}


//# sourceMappingURL=index.f93e2814.js.map
